import '/assets/styles/sections/web-menu-landing.scss';
import config from '/config';
import { useMemo } from 'react';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Btn from '/views/partials/btn';

// Context
import { useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';
import image_app_btn_apple from '/assets/images/partials/app-links/btn-app-apple.svg';
import image_app_btn_google from '/assets/images/partials/app-links/btn-app-google.svg';
import branchFeedbackFormIndex from '../../data/branch-feedback-form-index';

const WebMenuLanding = () => {
	const { branchSlug, tableId } = useParams('webMenu');

	const feedbackUrl = useMemo(() => {
		return branchFeedbackFormIndex[branchSlug];
	}, [branchSlug]);

	return (
		<section className="section web-menu-landing">
			<Img src={image_logo} lazy={false} className="landing-logo" alt="IF Sokak" />

			<div className="landing-opts">
				<div className="opts-opt opts-menu">
					{!!branchSlug && (
						<Btn
							tag="link"
							href="webMenuDisplayed"
							params={{
								branchSlug,
								tableId,
							}}
							icon="store"
							className="white big rounded"
						>
							Menüye Git
						</Btn>
					)}
				</div>

				<div className="opts-opt opts-download">
					<strong className="download-title">Mobil uygulamamızı indirerek hızlı ve sıra beklemeden sipariş verebilir, masaya getir özelliği ile yerinizden kalkmadan siparişinize ulaşabilirsiniz.</strong>
					<ul className="download-links">
						{!!config?.nativeApp?.appStoreLink && (
							<li className="links-link android">
								<Btn
									raw
									tag="link"
									target="_blank"
									rel="noopener noreferrer"
									className="link-btn block black rounded"
									href={config.nativeApp.appStoreLink}
								>
									<Img alt="Google Play Store" src={image_app_btn_apple} />
								</Btn>
							</li>
						)}
						{!!config?.nativeApp?.playStoreLink && (
							<li className="links-link ios">
								<Btn
									raw
									tag="link"
									target="_blank"
									rel="noopener noreferrer"
									className="link-btn block black rounded"
									href={config.nativeApp.playStoreLink}
								>
									<Img alt="App Store" src={image_app_btn_google} />
								</Btn>
							</li>
						)}
					</ul>
				</div>
				
				{feedbackUrl &&
					<div className="opts-opt opts-feedback">
						<Btn
							href={feedbackUrl}
							tag="link"
							className="nude hyperlink"
							raw>
							Şikayet ve Öneri
						</Btn>
					</div>
				}
			</div>
		</section>
	);
};

export default WebMenuLanding;
